// 고객 요청 사항으로 독서 챌린지 오픈 (2026. 01. 06)
import request from 'services/request';
import { endpoints } from 'services/endpoints';
import { paramsToFormData } from 'utils/utils';
import { PagingReqDto } from '../../types';

// 고객 요청 사항으로 독서 챌린지오픈 (2026. 01. 06)
export interface BookstoreBoardsRequest extends PagingReqDto {
  /** 카테고리 목록 */
  cateList?: string;
  /** 게시판 유형 */
  boardType?: string;
  /** 상단 통함 검색어 */
  topSearchWord?: string;
  /** 게시판 내 검색어 */
  searchWordIn?: string;
}

export interface BookstoreBoardUpdateReq extends BookstoreBoardDetailReqDto {
  uploadedFiles: AttachFileResDto[];
}

export interface BookstoreBoardLikeReq {
  boardId: string;
}

export interface BookstoreBoardDeleteReq {
  boardId: string;
}

// 고객 요청 사항으로 독서 챌린지 오픈 (2026. 01. 06)
export default {
  getBookstoreBoardList: (params: BookstoreBoardsRequest): Promise<BookstoreBoardListResDto> =>
    request({
      url: endpoints.bookstoreBoards.bookstoreBoard,
      method: 'get',
      params,
    }),
  getBookstoreBoardDetail: (url: string): Promise<BookstoreBoardDetailResDto> =>
    request({
      url,
      method: 'get',
    }),
  postBookstoreBoardWrite: (params: BookstoreBoardDetailReqDto): Promise<BaseResDto> => {
    const postParams = {
      ...params,
      boardType: params.boardType || 'BOOKSTORE_BOARD',
    } as BookstoreBoardDetailReqDto;

    if (!!params.attachFiles?.length) {
      for (let i = 0; i < params.attachFiles.length; i++) {
        postParams['attachFiles[' + i + '].attachFile'] = params.attachFiles[i];
        postParams['attachFiles[' + i + '].attachFileId'] = '0';
      }
    }

    if (!params.attachFiles?.length) {
      delete postParams.attachFiles;
    }

    const formData = paramsToFormData(postParams);

    return request(
      {
        url: endpoints.bookstoreBoards.bookstoreBoardWrite,
        method: 'post',
        data: formData,
      },
      {
        multiPart: true,
      }
    );
  },
  putBookstoreBoardUpdate: (url: string, params: BookstoreBoardUpdateReq): Promise<BaseResDto> => {
    const postParams = {
      ...params,
      boardType: params.boardType || 'BOOKSTORE_BOARD',
    } as BookstoreBoardUpdateReq;

    const uploadedFilesLength = params.uploadedFiles.length;

    for (let i = 0; i < uploadedFilesLength; i++) {
      postParams['attachFiles[' + i + '].attachFileId'] = params.uploadedFiles[i].fileId;
    }

    if (params.attachFiles?.length) {
      for (let i = 0; i < params.attachFiles.length; i++) {
        postParams['attachFiles[' + (uploadedFilesLength + i) + '].attachFile'] = params.attachFiles[i];
        postParams['attachFiles[' + (uploadedFilesLength + i) + '].attachFileId'] = '0';
      }
    }

    if (!params.attachFiles?.length) {
      delete postParams.attachFiles;
    }

    const formData = paramsToFormData(postParams);

    return request(
      {
        url: url,
        method: 'put',
        data: formData,
      },
      {
        multiPart: true,
      }
    );
  },
  postBookstoreBoardLike: (params: BookstoreBoardLikeReq): Promise<BaseResDto> =>
    request({
      url: endpoints.bookstoreBoards.bookstoreBoardLike,
      method: 'post',
      params,
    }),
  deleteBookstoreBoard: (url: string, params?: BookstoreBoardDeleteReq): Promise<BaseResDto> =>
    request({
      url,
      method: 'delete',
      params,
    }),
  shareBookstoreBoard: (params: ShareReqDto): Promise<BaseResDto> =>
    request({
      url: endpoints.bookstoreBoards.bookstoreBoardShare,
      method: 'post',
      data: params,
    }),
};
